import { render, staticRenderFns } from "./pickList.vue?vue&type=template&id=61db919a&scoped=true"
import script from "./pickList.vue?vue&type=script&lang=js"
export * from "./pickList.vue?vue&type=script&lang=js"
import style0 from "./pickList.vue?vue&type=style&index=0&id=61db919a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db919a",
  null
  
)

export default component.exports